import React from 'react';

export const styles: { [key: string]: React.CSSProperties } = {
    // --- Main Layout ---
    container: { backgroundColor: '#F8F9FA', minHeight: '100vh' },
    topBar: { background: '#FFFFFF', padding: '16px 30px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px', borderBottom: '1px solid #E0E0E0' },
    topBarTitle: { color: '#141414', margin: 0, fontSize: '24px', fontWeight: '700' },
    buttonGroup: { display: 'flex', gap: '12px' },

    // --- Dashboard Layout ---
    dashboardContent: { display: 'flex', flexDirection: 'row', gap: '24px', marginTop: '20px' },
    leftColumn: { flex: 3, display: 'flex', flexDirection: 'column', gap: '24px' },
    rightColumn: { flex: 2, display: 'flex', flexDirection: 'column', gap: '24px' },

    // --- Cards ---
    card: { background: '#FFFFFF', borderRadius: '12px', padding: '24px', border: '1px solid #E0E0E0', width: '100%' },
    cardTitle: { color: '#141414', fontSize: '20px', fontWeight: '600', marginBottom: '20px' },

    // --- Text ---
    primaryText: { color: '#141414' },
    secondaryText: { color: '#555555' },

    // --- Stats ---
    statsValue: { color: '#141414', fontSize: '28px', fontWeight: 'bold' },
    statsLabel: { color: '#555555', fontSize: '14px', marginBottom: '5px' },

    // --- Tables ---
    table: { width: '100%', borderCollapse: 'separate', borderSpacing: '0' },
    tableHeader: { color: '#555555', fontWeight: '600', padding: '12px 15px', borderBottom: '2px solid #E0E0E0', textAlign: 'left', fontSize: '12px', textTransform: 'uppercase', letterSpacing: '0.5px' },
    tableCell: { padding: '15px', color: '#555555', fontSize: '14px', verticalAlign: 'middle', borderBottom: '1px solid #E0E0E0' },

    // --- Badges ---
    badge: { padding: '5px 10px', borderRadius: '16px', fontWeight: 'bold', fontSize: '11px', textAlign: 'center', display: 'inline-block' },

    // --- Buttons ---
    button: { padding: '10px 20px', borderRadius: '8px', border: 'none', cursor: 'pointer', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: '8px', fontSize: '14px', fontWeight: '600', transition: 'all 0.2s ease' },
    primaryButton: { backgroundColor: '#0065FF', color: '#FFFFFF' },
    secondaryButton: { backgroundColor: '#FFFFFF', color: '#0065FF', border: '1px solid #0065FF' },
    dangerButton: { backgroundColor: '#dc3545', color: '#FFFFFF' },

    // --- Inputs ---
    searchInput: { width: '100%', padding: '12px 18px', fontSize: '16px', color: '#242424', backgroundColor: '#FFFFFF', border: '1px solid #D1D1D1', borderRadius: '8px', outline: 'none' },
    modalInput: { width: '100%', padding: '12px 16px', marginTop: '10px', backgroundColor: '#F8F9FA', border: '1px solid #D1D1D1', borderRadius: '8px', color: '#242424', fontSize: '16px' },

    // --- Empty State ---
    emptyState: { display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '48px', textAlign: 'center', color: '#555555', backgroundColor: '#FFFFFF', borderRadius: '12px', border: '1px solid #E0E0E0', minHeight: '300px' },

    // --- Modals ---
    modalOverlay: { display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: 'rgba(0, 0, 0, 0.5)', position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, zIndex: 1050 },
    modalContent: { background: '#FFFFFF', padding: '32px', borderRadius: '16px', width: '90%', maxWidth: '500px', border: '1px solid #E0E0E0', boxShadow: '0 8px 24px rgba(0, 0, 0, 0.1)' },
    modalTitle: { color: '#141414', marginBottom: '16px', fontSize: '24px', fontWeight: '700' },
    modalText: { color: '#555555', marginBottom: '24px' },
    modalFooter: { display: 'flex', gap: '12px', marginTop: '32px', justifyContent: 'flex-end' },
};
